module.exports = __webpack_public_path__ + "img/meta-trader5.548270c1.png";